export enum TransportType {
    UNKNOWN = 0,
    FOOT = 1,
    PUBLIC_TRANSPORT = 2
}
